import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_LP_WIDGET_TYPE_ID} from './dex-lp-widget-type-id';
import {DexLpWidgetComponent} from './dex-lp-widget.component';
import {DexLpWidgetImplementation} from './dex-lp-widget.implementation';
import {DexLpWidgetSettingsComponent} from './settings/dex-lp-widget-settings.component';
import {DexLpWidgetSettingsService} from './settings/dex-lp-widget-settings.service';

export const DEX_LP_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_LP_WIDGET_TYPE_ID,
    widgetLabel:               'Liquidity Pool Explorer',
    widgetImplementationType:  DexLpWidgetImplementation,
    widgetComponentType:       DexLpWidgetComponent,
    widgetSettingsServiceType: DexLpWidgetSettingsService,
    settingsSchema:            [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          true,
    widgetSettingsComponentType: DexLpWidgetSettingsComponent
};
